import React, { Component } from 'react';
import validator from 'validator';
import { DB_CONFIG } from '../../config/firebase.config';
import firebase from 'firebase';
import Header from '../survey/Header';
import Footer from '../survey/Footer';
import './Login.css';

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.app = firebase.initializeApp(DB_CONFIG);
    this.database = this.app
      .database()
      .ref()
      .child('enterprises');
    this.state = {
      firstname: '',
      lastname: '',
      telephone: '',
      quantityEmployees: '',
      enterprise: '',
      email: '',
      error: ''
    };
  }

  componentDidMount() {
    window.init();
    var addScript = document.createElement('script');
    addScript.setAttribute('src', '/js/functions.js');
    document.body.appendChild(addScript);
  }

  onChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    if (
      validator.isEmpty(this.state.enterprise) ||
      validator.isEmpty(this.state.email) ||
      validator.isEmpty(this.state.firstname) ||
      validator.isEmpty(this.state.lastname) ||
      validator.isEmpty(this.state.telephone) ||
      validator.isEmpty(this.state.quantityEmployees)
    ) {
      this.setState({ error: 'Todos los campos son requeridos' });
      return false;
    }

    if (!validator.isEmail(this.state.email)) {
      this.setState({ error: 'Ingrese un email válido' });
      return false;
    }

    let enterprise = {
      nombres: this.state.firstname,
      apellidos: this.state.lastname,
      telefono: this.state.telephone,
      email: this.state.email,
      empresa: this.state.enterprise,
      cantidadEmpleados: this.state.quantityEmployees
    };

    this.database
      .orderByChild('email')
      .equalTo(enterprise.email)
      .on('value', snap => {
        if (snap.val()) {
          this.setState({ error: 'Email introducido ya existe' });
          return false;
        } else {
          this.setState({ error: '' });
          this.database.push(enterprise, e => {
            this.setState({ error: '' });
            this.props.handleAuth();
          });
        }
      });
    this.props.handleAuth();
  };

  render() {
    return (
      <React.Fragment>
        <section className="form-section">
          <div className="logo-login">
            <img src="img/logowhite.png" alt="" />
          </div>
          <div className="form-container">
            <div className="form_content">
              <h2>Foko Consulting</h2>
              <p>
                Somos un equipo enfokado en la formación y desarrollo de líderes
                comprometidos con la excelencia y con la visión de ser mejores.
              </p>
              <a
                href="https://www.fokoconsulting.com"
                rel="noopener noreferrer"
                target="_blank"
              >
                Conoce más
              </a>
            </div>
            <div className="login_form">
              <h1>Ingresar</h1>
              {this.state.error && (
                <div className="error">{this.state.error}</div>
              )}

              <form onSubmit={this.handleSubmit}>
                <input
                  type="text"
                  name="firstname"
                  value={this.state.firstname}
                  onChange={this.onChange}
                  maxLength="30"
                  placeholder="Nombre"
                />
                <input
                  type="text"
                  name="lastname"
                  value={this.state.lastname}
                  onChange={this.onChange}
                  maxLength="20"
                  placeholder="Apellido"
                />
                <input
                  type="text"
                  name="telephone"
                  value={this.state.telephone}
                  onChange={this.onChange}
                  maxLength="15"
                  placeholder="Teléfono"
                />
                <input
                  type="text"
                  name="enterprise"
                  value={this.state.enterprise}
                  onChange={this.onChange}
                  maxLength="40"
                  placeholder="Nombre de la empresa"
                />
                <input
                  type="text"
                  name="quantityEmployees"
                  value={this.state.quantityEmployees}
                  onChange={this.onChange}
                  maxLength="15"
                  placeholder="Cantidad de empleados"
                />
                <input
                  type="text"
                  name="email"
                  value={this.state.email}
                  maxLength="50"
                  onChange={this.onChange}
                  placeholder="Email"
                />
                <input type="submit" name="" value="Ingresar" />
              </form>
            </div>
          </div>
          <div className="footer-copy">
            <img src="img/footercopy.png" alt="" />
          </div>
        </section>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/Login.jsx